export default "__VITE_ASSET__948064e5__"